import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { TextFormat, Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './signature-audit-log.reducer';

export const SignatureAuditLog = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const signatureAuditLogList = useAppSelector(state => state.signatureAuditLog.entities);
  const loading = useAppSelector(state => state.signatureAuditLog.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="signature-audit-log-heading" data-cy="SignatureAuditLogHeading">
        <Translate contentKey="crawlerBackendApp.signatureAuditLog.home.title">Signature Audit Logs</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.signatureAuditLog.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/signature-audit-log/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.signatureAuditLog.home.createLabel">
              Create new Signature Audit Log
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {signatureAuditLogList && signatureAuditLogList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.signatureAuditLog.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('eventType')}>
                  <Translate contentKey="crawlerBackendApp.signatureAuditLog.eventType">Event Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('eventType')} />
                </th>
                <th className="hand" onClick={sort('actor')}>
                  <Translate contentKey="crawlerBackendApp.signatureAuditLog.actor">Actor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('actor')} />
                </th>
                <th className="hand" onClick={sort('ipAddress')}>
                  <Translate contentKey="crawlerBackendApp.signatureAuditLog.ipAddress">Ip Address</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ipAddress')} />
                </th>
                <th className="hand" onClick={sort('eventTimestamp')}>
                  <Translate contentKey="crawlerBackendApp.signatureAuditLog.eventTimestamp">Event Timestamp</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('eventTimestamp')} />
                </th>
                <th className="hand" onClick={sort('note')}>
                  <Translate contentKey="crawlerBackendApp.signatureAuditLog.note">Note</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('note')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.signatureAuditLog.signingSession">Signing Session</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {signatureAuditLogList.map((signatureAuditLog, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/signature-audit-log/${signatureAuditLog.id}`} color="link" size="sm">
                      {signatureAuditLog.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.SignatureEventType.${signatureAuditLog.eventType}`} />
                  </td>
                  <td>{signatureAuditLog.actor}</td>
                  <td>{signatureAuditLog.ipAddress}</td>
                  <td>
                    {signatureAuditLog.eventTimestamp ? (
                      <TextFormat type="date" value={signatureAuditLog.eventTimestamp} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{signatureAuditLog.note}</td>
                  <td>
                    {signatureAuditLog.signingSession ? (
                      <Link to={`/signing-session/${signatureAuditLog.signingSession.id}`}>
                        {signatureAuditLog.signingSession.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/signature-audit-log/${signatureAuditLog.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/signature-audit-log/${signatureAuditLog.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/signature-audit-log/${signatureAuditLog.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.signatureAuditLog.home.notFound">
                No Signature Audit Logs found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default SignatureAuditLog;
